import React from 'react';
import { Star, Quote } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const testimonials = [
  {
    id: 1,
    quote: 'This course transformed my life. I finally understand how to balance my drive and ambition with compassion and intuition.',
    name: 'Sarah Mitchell',
    role: 'Entrepreneur',
    initial: 'S',
    color: 'bg-emerald-500'
  },
  {
    id: 2,
    quote: 'As a man, I struggled with accessing my feminine energy. This course gave me the tools and confidence to embrace all aspects of myself.',
    name: 'Michael Chen',
    role: 'Life Coach',
    initial: 'M',
    color: 'bg-blue-500'
  },
  {
    id: 3,
    quote: 'The integration practices are incredible. I\'ve experienced profound healing in my relationships and creative work.',
    name: 'Emma Rodriguez',
    role: 'Artist',
    initial: 'E',
    color: 'bg-purple-500'
  },
  {
    id: 4,
    quote: 'I was skeptical at first, but the results speak for themselves. I\'ve found balance between my professional drive and personal relationships.',
    name: 'David Thompson',
    role: 'Corporate Executive',
    initial: 'D',
    color: 'bg-amber-500'
  }
];

const TestimonialsSection = () => {
  const { t } = useLanguage();

  return (
    <section id="testimonials" className="py-16 md:py-24 bg-[#1a1f2e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('whatStudentsSay')}
          </h2>
          <p className="text-gray-400 text-lg">{t('testimonialsDesc')}</p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-[#232836] rounded-xl p-6 md:p-8 border border-gray-700/50 hover:border-gray-600 transition-all duration-300 relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 text-[#d4a33a]/20">
                <Quote className="w-12 h-12" />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star key={i} className="w-5 h-5 text-[#d4a33a] fill-[#d4a33a]" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-300 leading-relaxed mb-6 relative z-10">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className={`w-12 h-12 ${testimonial.color} rounded-full flex items-center justify-center text-white font-bold text-lg`}>
                  {testimonial.initial}
                </div>
                <div>
                  <h4 className="text-white font-semibold">{testimonial.name}</h4>
                  <p className="text-gray-400 text-sm">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Rating Summary */}
        <div className="flex items-center justify-center gap-4">
          <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star key={i} className="w-6 h-6 text-[#d4a33a] fill-[#d4a33a]" />
            ))}
          </div>
          <span className="text-white text-2xl font-bold">4.9</span>
          <span className="text-gray-400">{t('testimonialRating')}</span>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
